import colors from 'styles/colors'

export const defaultStyles = {
  container: {
    padding: '65px 0em',
    border: 0,
    width: '100%'
  },
  content: {
    marginTop: 30
  },
  segment: {
    border: 0,
    boxShadow: 'none',
    backgroundColor: colors.whiteSmoke,
    marginTop: '30px',
    padding: 0
  },
  nehrComment: {
    fontFamily: 'Barlow',
    fontSize: 20,
    color: colors.lightBlack,
    marginBottom: 20
  },
  providerCard: {
    container: {
      marginBottom: '20px'
    }
  }
}
